import { call, put } from 'redux-saga/effects';
import { Notifications } from 'types';
import { webSocketService } from 'services/WebSocketService';
import { ActionType } from 'typesafe-actions';
import { cancelLastCardAction, cancelLastCardFailureAction } from 'data/reducers';

import { responseType } from 'constants/common';

export function* cancelLastCardSaga({
  payload: { shiftManagerId },
}: ActionType<typeof cancelLastCardAction>) {
  const { type, data } = yield call(() =>
    webSocketService.sendMessage({
      type: Notifications.CANCEL_LAST_CARD,
      data: { shiftManagerId },
    }),
  );

  if (type === responseType.Error) {
    yield put(cancelLastCardFailureAction(data));
  }
}
